module.exports = __webpack_public_path__ + "static/media/battles-info-box.4afe3441.png";